const KYCPagination = ({ pagination, currentPage, setCurrentPage }) => {
  return (
    <div className="d-flex justify-content-center">
      <div>
        {currentPage !== 1 && (
          <button className="btn btn-primary mr-2" onClick={() => setCurrentPage((current) => current - 1)}>
            ก่อนหน้า
          </button>
        )}
        <button className="btn btn-primary" disabled>
          {currentPage}
        </button>
        {pagination?.hasNext && (
          <button className="btn btn-primary ml-2" onClick={() => setCurrentPage((current) => current + 1)}>
            ถัดไป
          </button>
        )}
      </div>
    </div>
  )
}

export default KYCPagination
